<template>
  <div class="star-rating" :class="{ sel: sel, hoved: hoved}" 
      v-on:click="$emit('click', rating)"
      v-on:mouseover="$emit('hover', rating)" v-html="star"></div>
</template>

<script>
export default {
  props: {
    sel: Boolean,
    hoved: Boolean,
    rating: Number
  },
  computed: {
    star () {
      if(this.sel || this.hoved) {
        return '&#9733;'
      }
      return '&#9734';
    }
  }
}
</script>

<style>
.star-rating{
  transition: all 0.1s linear;
  cursor:pointer;
  font-size:60px;
  color:#ffaa00;
  display:inline-block;
  position: relative;
  padding:0 10px 10px 10px;
}



.star-rating.hoved{
  transform: scale(1.2);
}

.star-rating:hover{
  color:#ff8c00;
}
</style>